// Sample card from Airbnb
import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom"
import { ParentCard } from "./style"
import Card from '../../components/Card';
import { useParams } from "react-router-dom";
import {Box, Center, Text, VStack} from '@chakra-ui/react';
import APIConfig from "../../api/APIConfig";
import ReactLoading from "react-loading";

function recruitmentTime(string){
    return new Date(string).getMonth();
}

function publishDay(string){
    return new Date(string).getDate();
}

const ItemTersimpan = () => {
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams();
    const [lowongan, setLowongan] = useState([]);
    const [isExist, setIsExist] = useState(true);
    let d = new Date().getDate();

    const getLowongan = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/list-lowongan-tersimpan-peserta/${id}`);
        const result = await response.data;
        setLowongan(result);
        if (result==='') {
            setIsExist(false)
        }
        setSpinner(false);
    };

    lowongan.map((data) => (console.log(data)))
    
    useEffect(() => {
        getLowongan();
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <div>
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <Box 
                spacing={'50px'}
                align='stretch'
                >
                    {isExist===true ? 
                    <Text
                        pt={5}
                        paddingBottom={7}
                        color={'gray.900'}
                        fontWeight={650}
                        fontSize={'3xl'}>
                        Item Tersimpan
                    </Text> :
                    <Text
                        paddingBottom={7}
                        color={'gray.900'}
                        fontWeight={500}
                        fontSize={'2xl'}>
                        Belum ada Item Tersimpan.
                    </Text>
                    }
                    <ParentCard>
                    {lowongan.map((data) => (
                        <Link to={`/lowongan/detail/${id}/${data.lowongan.idLowongan}`}
                            style={{color:'#000000', textDecoration: 'none'}}>
                            <Card 
                                jabatan={data.lowongan.proposal.namaPosisi}
                                perusahaan={data.lowongan.mitra.namaResmi}
                                durasi={`${recruitmentTime(data.lowongan.proposal.tanggalSelesai) - recruitmentTime(data.lowongan.proposal.tanggalMulai)} bulan`}
                                lokasi={data.lowongan.proposal.lokasi}
                                waktuPost={`${d - publishDay(data.lowongan.waktuDipublish)} hari yang lalu`}
                                logo={data.lowongan.mitra.image}
                                nominal={data.lowongan.proposal.nominal}
                                />
                        </Link>
                    ))}
                    </ParentCard>

                </Box>
            </Box>
        </VStack>
        </Center>
        </div>
      );
  }

export default ItemTersimpan;